<template>
<div>
  <div class="properties">
    <property name="סוג מנוי" value="פעיל"/>
    <property name="תאריך חיוב הבא" :value="nextPaymentDateDisplayValue"/>
  </div>
  <separator/>
  <update-credit-card-button/>
</div>
</template>

<script>
import { mapState } from 'vuex';
import BaseUI from 'base-ui';
import Property from './Property.vue';
import UpdateCreditCardButton from './components/UpdateCreditCardButton.vue';
import dates from '../../../../../utils/dates';

export default {
  name: 'SubscribedSettings',
  components: {
    UpdateCreditCardButton,
    Property,
    Separator: BaseUI.Separator,
  },
  computed: {
    ...mapState('subscriptionState', ['nextPaymentDate']),
    nextPaymentDateDisplayValue() {
      return this.nextPaymentDate ? dates.longHebrewDateFormat(this.nextPaymentDate) : 'בבדיקה';
    },
  },
};
</script>

<style scoped lang="scss">

  @import "./settings";

  @include properties;

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/account-settings/SubscribedSettings.vue